import { FilterType, } from "../models";
import { deserializeSearchFilter, deserializeIncludeDiscontinuedFilter, } from "../utils/deserialize-search-filter";
import { getSearchFilterIndex } from "../utils/get-search-filter-index";
import { getIncludeDiscontinuedFilterIndex } from "../utils/get-include-discontinued-filter-index";
import { StaticLocationParamaters, } from "cg-foundation-theming";
var SEARCH_QUERY_MIN_LENGTH = 2;
var FiltersComponentController = (function () {
    function FiltersComponentController(locationService) {
        this.locationService = locationService;
        this.loading = true;
        this.filterGroups = [];
        this.selectedFilters = [];
        this.initiallySelectedFilters = [];
        this.includeDiscontinued = null;
    }
    FiltersComponentController.prototype.$onChanges = function () {
        this.selectedFilters = this.initiallySelectedFilters || [];
        this.initCheckedState();
        var searchFilterGroup = this.filterGroups.filter(function (x) { return x.name.toLowerCase() === "search"; })[0];
        if (searchFilterGroup) {
            var searchFilterIndex = getSearchFilterIndex(this.selectedFilters);
            if (searchFilterIndex > -1) {
                var deserializedSearchObject = deserializeSearchFilter(this.selectedFilters[searchFilterIndex]);
                searchFilterGroup.searchQuery = deserializedSearchObject.searchQuery;
            }
        }
        this.$initCollapseState();
        this.loading = this.filterGroups.length === 0;
    };
    FiltersComponentController.prototype.isFilterChecked = function (filterId) {
        return this.selectedFilters.indexOf(filterId) > -1;
    };
    FiltersComponentController.prototype.OnIncludeDiscontinuedChange = function () {
        sessionStorage.setItem("checked-state-includeDiscontinued", String(this.includeDiscontinued));
        var includeDiscontinuedFilterValue = "includeDiscontinued," + this.includeDiscontinued;
        var includeDiscontinuedFilterIndex = getIncludeDiscontinuedFilterIndex(this.selectedFilters);
        if (includeDiscontinuedFilterIndex === -1) {
            this.selectedFilters.push(includeDiscontinuedFilterValue);
        }
        else {
            this.selectedFilters[includeDiscontinuedFilterIndex] =
                includeDiscontinuedFilterValue;
        }
        this.onFilterChange({ selectedFilters: this.selectedFilters });
    };
    FiltersComponentController.prototype.searchChange = function (searchQuery) {
        if (searchQuery && searchQuery.length < SEARCH_QUERY_MIN_LENGTH) {
            return;
        }
        var searchFilterValue = "search," + searchQuery;
        var searchFilterIndex = getSearchFilterIndex(this.selectedFilters);
        if (searchFilterIndex === -1) {
            this.selectedFilters.push(searchFilterValue);
        }
        else {
            this.selectedFilters[searchFilterIndex] = searchFilterValue;
        }
        this.onFilterChange({ selectedFilters: this.selectedFilters });
    };
    FiltersComponentController.prototype.toggleFilter = function (filterId, filter) {
        var filterIndex = this.selectedFilters.indexOf(filterId);
        filter.selected = filter.selected === undefined ? 0 : filter.selected;
        if (filterIndex === -1) {
            this.selectedFilters.push(filterId);
            filter.selected++;
        }
        else {
            this.selectedFilters.splice(filterIndex, 1);
            filter.selected--;
        }
        this.onFilterChange({ selectedFilters: this.selectedFilters });
    };
    FiltersComponentController.prototype.clearAll = function () {
        this.selectedFilters = [];
        this.onFilterChange({ selectedFilters: this.selectedFilters });
    };
    FiltersComponentController.prototype.toggleFilterGroup = function (filterGroup) {
        filterGroup.collapsed = !filterGroup.collapsed;
        sessionStorage.setItem("collapse-state-" + filterGroup.name, String(filterGroup.collapsed));
    };
    FiltersComponentController.prototype.getFilterTemplate = function (filterGroup) {
        var filterGroupName = filterGroup.name.toLowerCase();
        var templateName = filterGroupName === FilterType.Search
            ? FilterType.Search
            : FilterType.Regular;
        return "compatibilityguide/ng-templates/feature/search/filter" + templateName;
    };
    FiltersComponentController.prototype.$initCollapseState = function () {
        var _this = this;
        for (var _i = 0, _a = this.filterGroups; _i < _a.length; _i++) {
            var filterGroup = _a[_i];
            var sessionStorageState = sessionStorage.getItem("collapse-state-" + filterGroup.name);
            if (sessionStorageState !== null) {
                filterGroup.collapsed = sessionStorageState === "true";
            }
            else if (filterGroup.filters.some(function (f) { return _this.selectedFilters.indexOf(f.id) > -1; })) {
                filterGroup.collapsed = false;
            }
        }
    };
    FiltersComponentController.prototype.initCheckedState = function () {
        var filters = this.locationService.get(StaticLocationParamaters.filters);
        var includeDiscontinuedFilterIndex = getIncludeDiscontinuedFilterIndex(this.selectedFilters);
        if (includeDiscontinuedFilterIndex === -1) {
            var checkedState = sessionStorage.getItem("checked-state-includeDiscontinued");
            this.includeDiscontinued = checkedState === "true";
            return;
        }
        this.includeDiscontinued =
            deserializeIncludeDiscontinuedFilter(filters).searchQuery === "true";
        this.OnIncludeDiscontinuedChange();
    };
    FiltersComponentController.$inject = ["locationService"];
    return FiltersComponentController;
}());
export var FiltersComponent = {
    bindings: {
        filterGroups: "<",
        initiallySelectedFilters: "<?",
        onFilterChange: "&?",
    },
    controller: FiltersComponentController,
    templateUrl: "compatibilityguide/ng-templates/feature/search/filters",
};
